import * as React from 'react';

const ActivityPaneContext = React.createContext<{
    ActivityPane?: React.FunctionComponent<{
        getCanvasPanZoomBounds: () => {
            bounds: { top: number; left: number; right: number; width: number; height: number };
            pan: { x: number; y: number };
            zoom: number;
        };
    }>;
}>({});

ActivityPaneContext.displayName = 'ActivityPaneContext';

export const ActivityPaneProvider = ActivityPaneContext.Provider;

export default function useActivityPaneContext() {
    return React.useContext(ActivityPaneContext);
}
